import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { updateUsers, editUsers } from "../../../apis/profileInfoApi";
import { profileSchema } from "../../../Validations/profileValidation";
export default function ProfileInformation() {
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [dataLoader, setDataLoader] = useState(false);

  const navigate = useNavigate();

  const currentUserId = localStorage.getItem("Id") || null;
  const [profileInitial, setProfileInitial] = useState({
    firstName: "",
    lastName: "",
    birthDate: "",
    address1: "",
    address2: "",
    city: "",
    country: "",
    county: "",
    mobile: "",
    password: "",
  });

  useEffect(() => {
    if (currentUserId) {
      editProfileInformation(currentUserId);
    }
  }, [currentUserId]);
  // }, [currentUserId]);

  const editProfileInformation = async (userId) => {
    if (!userId) {
      console.error("No user ID provided");
      return;
    }
    setDataLoader(true);
    try {
      const res = await editUsers(userId);
      console.log({ res123456789: res });
      if (res.result) {
        const userData = res.result;
        setDataLoader(false);
        console.log({ userData123456789: userData.info.address1 });
        setProfileInitial({
          firstName: userData.firstName || "",
          lastName: userData.lastName || "",
          birthDate: userData?.info?.dateOfBirth || "",
          mobile: userData?.mobile || "",
          country: userData?.info?.country || "",
          county: userData?.info?.county || "",
          address1: userData?.info?.address1 || "",
          address2: userData?.info?.address2 || "",
          city: userData?.info?.county || "",
          password: "",
        });
      } else {
        setDataLoader(false);
        console.log("No user data received");
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching user details:", error);
      setLoading(false);
    }
  };

  const formik = useFormik({
    initialValues: profileInitial,
    enableReinitialize: true,
    // validationSchema: profileSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        let res;
        if (currentUserId) {
          console.log({ values123456789: values });
          res = await updateUsers({
            userId: currentUserId,
            ...values,
          });
          if (res.success) {
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
        setLoading(false);
      }
    },
  });
  const backClick = () => {
    navigate("/news");
  };

  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            <i
              className="fas fa-arrow-left"
              style={{ marginRight: "30px", fontSize: "20px" }}
              onClick={backClick}
            />
            <div className="my-3 p-3 bg-body rounded shadow-sm">
              {dataLoader ? (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ height: "50px", padding: "7px 30px" }}
                >
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <form onSubmit={formik.handleSubmit}>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="input-block mb-3">
                            <label className="col-form-label">First Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="firstName"
                              value={formik.values.firstName}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />
                            {formik.errors.firstName &&
                            formik.touched.firstName ? (
                              <span className="text-danger">
                                {formik.errors.firstName}
                              </span>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="input-block mb-3">
                            <label className="col-form-label">Last Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="lastName"
                              value={formik.values.lastName}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />
                            {formik.errors.lastName &&
                            formik.touched.lastName ? (
                              <span className="text-danger">
                                {formik.errors.lastName}
                              </span>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="input-block mb-3">
                            <label className="col-form-label">
                              Date Of Birth
                            </label>
                            <input
                              type="date"
                              name="birthDate"
                              className="form-control"
                              value={formik.values.birthDate}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />
                            {formik.errors.birthDate &&
                            formik.touched.birthDate ? (
                              <span className="text-danger">
                                {formik.errors.birthDate}
                              </span>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="input-block mb-3">
                            <div className="d-flex justify-content-between">
                              <label className="col-form-label">Password</label>
                              <i
                                className="fa fa-pencil m-r-5 mt-3"
                                onClick={() => setShowPassword(!showPassword)}
                                style={{ height: "16px", marginTop: "16px" }}
                              ></i>
                            </div>
                            {!showPassword && (
                              <input
                                type="text"
                                className="form-control"
                                name=""
                                value="********"
                              />
                            )}
                            {showPassword && (
                              <input
                                type="text"
                                className="form-control"
                                name="password"
                                value={formik.values.password}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                            )}
                            {formik.errors.password &&
                            formik.touched.password ? (
                              <span className="text-danger">
                                {formik.errors.password}
                              </span>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="input-block mb-3">
                        <label className="col-form-label">Address 1</label>
                        <input
                          type="text"
                          name="address1"
                          className="form-control"
                          value={formik.values.address1}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          placeholder="Enter Address 1"
                        />
                        {formik.errors.address1 && formik.touched.address1 ? (
                          <span className="text-danger">
                            {formik.errors.address1}
                          </span>
                        ) : null}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="input-block mb-3">
                        <label className="col-form-label">Address 2</label>
                        <input
                          type="text"
                          name="address2"
                          className="form-control"
                          onChange={formik.handleChange}
                          value={formik.values.address2}
                          onBlur={formik.handleBlur}
                          placeholder="Enter Address 2"
                        />
                        {formik.errors.address2 && formik.touched.address2 ? (
                          <span className="text-danger">
                            {formik.errors.address2}
                          </span>
                        ) : null}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="input-block mb-3">
                        <label className="col-form-label">City</label>
                        <input
                          type="text"
                          className="form-control"
                          name="city"
                          onChange={formik.handleChange}
                          value={formik.values.city}
                          onBlur={formik.handleBlur}
                          placeholder="Enter City"
                        />
                        {formik.errors.city && formik.touched.city ? (
                          <span className="text-danger">
                            {formik.errors.city}
                          </span>
                        ) : null}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="input-block mb-3">
                        <label className="col-form-label">Mobile</label>
                        <input
                          type="text"
                          className="form-control"
                          name="mobile"
                          value={formik.values.mobile}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.errors.mobile && formik.touched.mobile ? (
                          <span className="text-danger">
                            {formik.errors.mobile}
                          </span>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  {loading ? (
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: "50px", padding: "7px 30px" }}
                    >
                      <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <div>
                      <button className="btn btn-primary " type="submit">
                        Update
                      </button>
                    </div>
                  )}
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
